export default {
      id: "reboot-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#reboot",
      toString: function () {
        return this.url;
      }
    }